import { webapiApi } from '../../webapiApi';

// =============================================================================
// Response Types (matching OpenAPI spec)
// =============================================================================

export interface ClientUserProfileResponse {
  id: string;
  name: string;
  email: string;
  role: 'Editor' | 'Admin' | null;
  pictureUrl: string | null;
}

export interface UpdateClientProfileParams {
  name: string;
}

export interface ClientTenantResponse {
  code: string;
  name: string;
  tenantId: string;
}

export interface ClientTenantsPagedResponse {
  items: ClientTenantResponse[];
  total: number;
  index: number;
  size: number;
}

// =============================================================================
// API Endpoints
// =============================================================================

export const clientUserProfileApi = webapiApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientProfile: builder.query<ClientUserProfileResponse, void>({
      query: () => '/profile',
      providesTags: [{ type: 'User', id: 'PROFILE' }],
    }),

    updateClientProfile: builder.mutation<ClientUserProfileResponse, UpdateClientProfileParams>({
      query: (body) => ({
        url: '/profile',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [{ type: 'User', id: 'PROFILE' }],
    }),

    updateClientProfileName: builder.mutation<ClientUserProfileResponse, UpdateClientProfileParams>({
      query: (body) => ({
        url: '/profile/name',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [{ type: 'User', id: 'PROFILE' }],
    }),

    getClientTenants: builder.query<ClientTenantsPagedResponse, void>({
      query: () => '/profile/tenants',
      providesTags: ['Tenant'],
    }),
  }),
});

export const {
  useGetClientProfileQuery,
  useUpdateClientProfileMutation,
  useUpdateClientProfileNameMutation,
  useGetClientTenantsQuery,
} = clientUserProfileApi;
